/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getReviewerPerformanceHeatmapV1QuerySchema = z.object({
  userId: z.string().min(1),
  days: z.coerce.number().int().min(1).max(90).default(28),
});

export type IGetReviewerPerformanceHeatmapV1Query = z.input<
  typeof getReviewerPerformanceHeatmapV1QuerySchema
>;
